// SkipReportsPage — /reports/skip-management.
//
// Index for the Skip Management report section. Replaces the old ComingSoon
// stub with a card grid linking to the four Phase 1 reports. Gated to
// admin + manager at the route level (see router.tsx).

import { Link } from 'react-router-dom';
import { type ComponentType } from 'react';
import { BarChart3, Container, TrendingUp, Users } from 'lucide-react';
import type { LucideProps } from 'lucide-react';
import { PageHeader } from '../../../components/ui/PageHeader/PageHeader';
import styles from './skipReports.module.css';

interface ReportLink {
  to: string;
  title: string;
  description: string;
  icon: ComponentType<LucideProps>;
}

const REPORTS: ReportLink[] = [
  {
    to: '/reports/skip-management/jobs',
    title: 'Jobs Overview',
    description: 'Job volume, revenue and status mix over the selected period.',
    icon: BarChart3,
  },
  {
    to: '/reports/skip-management/enquiries',
    title: 'Lead Conversion',
    description: 'Enquiry funnel, conversion rate and contact outcomes.',
    icon: TrendingUp,
  },
  {
    to: '/reports/skip-management/inventory',
    title: 'Inventory Utilisation',
    description: 'Fleet status, availability and per-unit usage in period.',
    icon: Container,
  },
  {
    to: '/reports/skip-management/customers',
    title: 'Customer Revenue',
    description: 'Revenue, volume and outstanding balances by customer.',
    icon: Users,
  },
];

export function SkipReportsPage(): JSX.Element {
  return (
    <div className={styles.page}>
      <PageHeader
        title="Skip Management Reports"
        subtitle="Operational, pipeline, fleet and revenue reports"
      />
      <div className={styles.cardGrid}>
        {REPORTS.map((r) => (
          <Link key={r.to} to={r.to} className={styles.reportCard}>
            <span className={styles.reportCardIcon}>
              <r.icon size={20} aria-hidden />
            </span>
            <span className={styles.reportCardTitle}>{r.title}</span>
            <p className={styles.reportCardDesc}>{r.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
